import { createModel } from '@rematch/core';
import { IRootModel } from 'app/store';
import { IAuthState } from 'entities/Auth/Auth.models';
import { authReducers } from 'entities/Auth/Auth.reducers';
import { authEffects } from 'entities/Auth/Auth.effects';

export const auth = createModel<IRootModel>()({
  state: {
    data: null,
    loading: true,
  } as IAuthState,
  reducers: authReducers,
  effects: authEffects,
});
